module.exports = __webpack_public_path__ + "img/newIndex.a41aa9fb.png";